/**
 * Created by vladislav on 2/13/2024
 */

const Requests = function () {
    connector.social.on("error:request", this.onError.bind(this));
};

Requests.prototype.send = function (to, type, payload, callback) {
    if (to && !Array.isArray(to)) {
        to = [to];
    }

    const picture = cleverapps.SocialManager.getShareData("default").image;

    const sendRequest = () => {
        connector.social.requestCallback({
            to,
            text: Messages.get(`${type}.message`),
            title: Messages.get(`${type}.title`),
            template: "game_invite",
            data: payload,
            image: picture
        }, (code, result) => {
            if (result && !Array.isArray(result)) {
                result = [result];
            }

            to = result || to;

            if (code === cleverapps.CODE_SUCCEED) {
                this.onSuccess(type, to);
            } else if (code === cleverapps.CODE_FAILED) {
                this.onFail(type, to);
            }

            if (callback) {
                callback(code, to);
            }
        });
    };

    if (connector.platform.isExitFullscreenAvailable()) {
        connector.platform.exitFullscreen(sendRequest);
    } else {
        sendRequest();
    }
};

Requests.prototype.onSuccess = function (type, to) {
    levels.friendSorter.markUsed(to);

    const friends = cleverapps.friends.listInAppIds();
    const sentToFriends = to.filter((sentId) => friends.indexOf(sentId) !== -1);

    if (sentToFriends.length > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.MESSAGE_SENT_FRIEND, { value: sentToFriends.length });
    }

    if (to.length - sentToFriends.length > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.MESSAGE_SENT_INVITE, { value: to.length - sentToFriends.length });
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.MESSAGE_SENT_PREFIX + type, { value: to.length });
};

Requests.prototype.onFail = function (type, to) {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.MESSAGE_CANCEL_PREFIX + type, { value: to.length });
};

Requests.prototype.onError = function (code) {
    if ([cleverapps.CODE_CANCELLED, cleverapps.CODE_CANCELLED_FACEBOOK_DIALOG].includes(code)) {
        let eventName = `${cleverapps.EVENTS.MESSAGE_ERROR}_${connector.info.source}`;
        if (typeof code === "number") {
            eventName += `_${code}`;
        }
        cleverapps.metrics.logEvent(eventName);
    }
};